import { isSameSearchCriteria } from "domains/publication/reducer";
import { getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import type { RootState } from "types/redux";

export const createKnowledgeFeedForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.knowledgeFeed.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, {
      ...getLatestSearchCriteria(state),
      id,
      secondaryTopicId: getTmSelectedOuterNodeId(state),
    }),
  );

export const getLatestSearchCriteria = (state: RootState) => state.domains.knowledgeFeed.searchCriteria;

export const getLatestFilterCount = (state: RootState) => {
  const { content_type, language, publication_type, role, search, year } = state.domains.knowledgeFeed.searchCriteria;
  let count = 0;
  if (content_type) count++;
  if (language) count++;
  if (publication_type) count++;
  if (role) count++;
  if (search) count++;
  if (year) count++;
  return count;
};
